import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/propgen_auth";
import { LayoutDashboard, LogOut, Plus, Users } from "lucide-react";

export default function Sidebar({ onNewProject }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const navItem = (to, icon, label, testid) => {
    const active = loc.pathname === to || (to !== "/" && loc.pathname.startsWith(to));
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`flex items-center gap-3 px-3 py-2 text-sm border-l-2 transition-colors duration-150 ${
          active
            ? "border-[var(--peak-blue)] bg-[var(--peak-blue)]/10 text-foreground font-medium"
            : "border-transparent text-muted-foreground hover:text-foreground hover:bg-muted"
        }`}
      >
        {icon}
        <span>{label}</span>
      </Link>
    );
  };

  return (
    <aside
      className="w-60 shrink-0 border-r bg-card flex flex-col h-screen sticky top-0"
      data-testid="app-sidebar"
    >
      <div className="p-4 border-b flex items-center gap-3">
        <div className="w-8 h-8 bg-[var(--peak-blue)] text-white flex items-center justify-center font-display font-black text-sm">P</div>
        <div>
          <div className="font-display font-black tracking-tight text-sm leading-none">PROPGEN</div>
          <div className="eyebrow !text-[9px] mt-1">PROPOSAL OPS</div>
        </div>
      </div>

      <div className="p-3">
        <button
          onClick={onNewProject}
          data-testid="sidebar-new-project-btn"
          className="w-full flex items-center justify-center gap-2 h-10 bg-black text-white hover:bg-[var(--peak-blue)] transition-colors duration-200 font-display font-bold text-xs tracking-wide uppercase"
        >
          <Plus className="w-4 h-4" /> New Project
        </button>
      </div>

      <nav className="flex-1 py-2">
        <div className="eyebrow px-4 mb-2">Workspace</div>
        {navItem("/superadmin/propgen", <LayoutDashboard className="w-4 h-4" />, "Projects", "nav-projects")}
        {user?.is_admin && (
          <>
            <div className="eyebrow px-4 mb-2 mt-6">Admin</div>
            {navItem("/superadmin/propgen/admin/users", <Users className="w-4 h-4" />, "Users", "nav-admin-users")}
          </>
        )}
      </nav>

      <div className="mt-auto border-t p-3">
        <div className="mb-2 px-2">
          <div className="text-xs font-medium truncate" data-testid="sidebar-user-name">
            {user?.name || user?.email}
          </div>
          <div className="text-[10px] text-muted-foreground font-mono uppercase tracking-wider">
            {user?.role || "member"}
          </div>
        </div>
        <button
          onClick={async () => {
            await logout();
            nav("/login", { replace: true });
          }}
          data-testid="sidebar-logout-btn"
          className="w-full flex items-center gap-2 px-2 py-2 text-xs text-muted-foreground hover:text-red-600 transition-colors duration-150"
        >
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </div>
    </aside>
  );
}
